import React, { useState } from 'react';

const AIChatSection = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setErrorMsg('');
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/subscribers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      const data = await res.json();
      if (data.success) {
        setSubscribed(true);
        setEmail('');
        setTimeout(() => setSubscribed(false), 5000);
      } else {
        setErrorMsg(data.error || 'No se pudo guardar la suscripción');
      }
    } catch (_) {
      setErrorMsg('Error de conexión. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section style={{
      background: 'var(--brand-primary)',
      padding: 'clamp(60px, 10vw, 100px) clamp(20px, 5vw, 60px)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Subtle decorative line */}
      <div style={{
        position: 'absolute',
        top: '50%',
        right: '-10%',
        width: '400px',
        height: '400px',
        border: '1px solid rgba(201, 169, 110, 0.08)',
        borderRadius: '50%',
        transform: 'translateY(-50%)'
      }} />

      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1
      }}>
        <p style={{
          color: 'var(--brand-secondary)',
          fontSize: '0.7rem',
          fontWeight: 500,
          textTransform: 'uppercase',
          letterSpacing: '0.3em',
          marginBottom: '16px',
          fontFamily: 'var(--font-body)'
        }}>
          Newsletter
        </p>

        <h2 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
          fontWeight: 300,
          color: '#ffffff',
          lineHeight: 1.15,
          marginBottom: '16px',
          letterSpacing: '0.03em'
        }}>
          Sé la Primera en Enterarte
        </h2>

        <p style={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: '0.9rem',
          lineHeight: 1.7,
          marginBottom: '32px',
          maxWidth: '450px',
          margin: '0 auto 32px'
        }}>
          Suscribite para recibir novedades, lanzamientos exclusivos y ofertas especiales directamente en tu casilla.
        </p>

        {subscribed ? (
          <div style={{
            padding: '16px 24px',
            border: '1px solid var(--brand-secondary)',
            color: 'var(--brand-secondary)',
            fontSize: '0.85rem',
            fontWeight: 500,
            letterSpacing: '0.1em',
            textTransform: 'uppercase'
          }}>
            <i className="fa-solid fa-check me-2"></i>
            ¡Gracias por suscribirte!
          </div>
        ) : (
          <form onSubmit={handleSubscribe} style={{
            display: 'flex',
            maxWidth: '460px',
            margin: '0 auto',
            gap: '0'
          }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Tu email"
              required
              style={{
                flex: 1,
                padding: '14px 20px',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRight: 'none',
                background: 'transparent',
                color: '#ffffff',
                fontSize: '0.85rem',
                fontFamily: 'var(--font-body)',
                outline: 'none',
                letterSpacing: '0.03em'
              }}
            />
            <button type="submit" disabled={loading} style={{
              padding: '14px 28px',
              background: 'var(--brand-secondary)',
              color: 'var(--brand-primary)',
              border: '1px solid var(--brand-secondary)',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.15em',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'var(--font-body)',
              transition: 'all 0.3s ease',
              whiteSpace: 'nowrap',
              opacity: loading ? 0.7 : 1
            }}
              onMouseEnter={e => { if (!loading) { e.target.style.background = 'transparent'; e.target.style.color = 'var(--brand-secondary)'; } }}
              onMouseLeave={e => { e.target.style.background = 'var(--brand-secondary)'; e.target.style.color = 'var(--brand-primary)'; }}
            >
              {loading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'Suscribirme'}
            </button>
          </form>
        )}
        {errorMsg && (
          <p style={{ color: 'rgba(255,100,100,0.9)', fontSize: '0.8rem', marginTop: 12, textAlign: 'center' }}>
            {errorMsg}
          </p>
        )}
      </div>

      <style>{`
        input::placeholder {
          color: rgba(255,255,255,0.35);
        }
        @media (max-width: 480px) {
          form {
            flex-direction: column !important;
          }
          form input {
            border-right: 1px solid rgba(255,255,255,0.2) !important;
            border-bottom: none !important;
          }
        }
      `}</style>
    </section>
  );
};

export default AIChatSection;
